import { render } from "./SubcategoryElement.vue?vue&type=template&id=7a9df0b7"
import script from "./SubcategoryElement.vue?vue&type=script&lang=js"
export * from "./SubcategoryElement.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__